import React, { ReactNode } from 'react';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprActionInfo } from '../../action/WprActionInfo';
import { WprBaseControlComponent } from './WprBaseControlComponent';
import { WprControlVisibility } from '../props/IWprControlState';

/**
 * ボタンコントロールプロパティ情報
 */
interface IWprButtonProps extends IWprControlProps {
}

/**
 * ボタンコントロール
 */
export class WprButton extends WprBaseControlComponent<IWprButtonProps, HTMLButtonElement> {
	// private 変数  ------------------------------------------------------------
	private m_ActionInfo: WprActionInfo		= null;		// アクション情報
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** 編集フラグ */
	public get isEdit(): boolean	{ return false; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprButtonProps) {
		super(props);
		if (this.props.row)
			this.m_ActionInfo = this.props.view.getActionInfo(this.props.name, this.props.row.listName);
		else
			this.m_ActionInfo = this.props.view.getActionInfo(this.props.name);
		if (this.m_ActionInfo == null) {
			if (this.props.row)
				this.props.view.addErrorLog(`アクションが登録されていません。[${this.props.name}][${this.props.row.listName}]`);
			else
				this.props.view.addErrorLog(`アクションが登録されていません。[${this.props.name}]`);
		}
		else {
			this.setClickEvent(this.onClick.bind(this));
		}
	}
	// --------------------------------------------------------------------------

	// イベント  ----------------------------------------------------------------
	/**
	 * ボタンクリック処理
	 * @param event 変更イベント 
	 */
	public onClick(event: React.MouseEvent<HTMLButtonElement>): void {
		if (this.m_ActionInfo != null) {
			if (this.props.row)
				this.m_ActionInfo.execute(event, this.props.row.rowData);
			else
				this.m_ActionInfo.execute(event);
		}
		else {
			this.props.view.addErrorLog(`アクションが登録されていません。[${this.props.name}]`);
		}
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値取得
	 * @returns 値
	 */
	protected getValue(): any {
		return undefined;
	}

	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.visibility === WprControlVisibility.COLLAPSED)
			return <></>;
		const props = this.getProps();
		const {name, view, className, children, ...other} = this.props;
		const state = this.getState(['style', 'disabled']);
		const events = this.getEvents();
		let button = null;
		if (this.state.visibility === WprControlVisibility.VISIBLE) {
			button = <button {...props} {...state} {...other} {...events}>{this.props.children}</button>;
		}
		else {
			button = <button hidden {...props} {...state} {...other}>{this.props.children}</button>;
		}
		return (
			<>
				{button}
			</>
		);
	}
	// --------------------------------------------------------------------------
}